import { createContext, useContext, type ReactNode } from 'react';

/** Inserts a synthetic assistant turn into the live chat session.
 *
 *  A2UI surface actions (e.g. EmailComposer.Send) post to the /surfaces/action
 *  endpoint, which writes a confirmation row to the DB but never reaches the
 *  open SSE stream — so the live chat doesn't see the result without a
 *  refetch. This appender lets the result text land in the chat immediately
 *  (success or failure) for persistent, in-thread feedback. */
export type AppendAssistantTurnFn = (text: string) => void;

const AppendAssistantTurnContext = createContext<AppendAssistantTurnFn | null>(
  null,
);

export interface AppendAssistantTurnProviderProps {
  readonly append: AppendAssistantTurnFn;
  readonly children: ReactNode;
}

export function AppendAssistantTurnProvider({
  append,
  children,
}: AppendAssistantTurnProviderProps) {
  return (
    <AppendAssistantTurnContext.Provider value={append}>
      {children}
    </AppendAssistantTurnContext.Provider>
  );
}

export function useAppendAssistantTurn(): AppendAssistantTurnFn | null {
  return useContext(AppendAssistantTurnContext);
}
